<template>
  <router-view />
</template>

<script>
import { isAgencyAuthenticated, isMusteriAuthenticated, clearInvalidTokens } from '@/services/auth';

export default {
  mounted() {
    clearInvalidTokens();
    const routeName = this.$route.name;
    const publicRoute = routeName === 'Login' || routeName === 'musterilogin';
    const musteriRoute = routeName === 'musteripanel';

    if (!isAgencyAuthenticated() && !isMusteriAuthenticated()) {
      if (!publicRoute) {
        this.$router.replace({ name: 'Login' });
      }
      return;
    }

    if (isMusteriAuthenticated() && !isAgencyAuthenticated() && !musteriRoute && !publicRoute) {
      this.$router.replace({ name: 'musteripanel' });
      return;
    }

    if (isAgencyAuthenticated() && (routeName === 'Login' || routeName === 'musterilogin')) {
      this.$router.replace({ name: 'anasayfa' });
    }
  },
};
</script>

